<template>
    <header :class="['header-container', {'is-dark': headerIsDark}]">

        <div class="header">

            <div class="logo">
                <img src="@/assets/images/Logo.svg" alt="logo">
            </div>

            <div class="header-separator">
                <span></span>
            </div>

            <ul class="navbar">

                <li data-anchor-link="home">
                    <a @click="scrollTo('home')">
                        Home
                    </a>
                </li>
                <li data-anchor-link="market">
                    <a @click="scrollTo('market')">
                        Market
                    </a>
                </li>
                <li data-anchor-link="features">
                    <a @click="scrollTo('features', 'start')">
                        Features
                    </a>
                </li>
                <li data-anchor-link="roadmap">
                    <a @click="scrollTo('roadmap')">
                        Roadmap
                    </a>
                </li>
                <li data-anchor-link="pricing">
                    <a @click="scrollTo('pricing')">
                        Pricing
                    </a>
                </li>
                <li data-anchor-link="funding">
                    <a @click="scrollTo('funding')">
                        Funding
                    </a>
                </li>
                <li>
                    <button class="btn is-rounded"
                            @click="scrollTo('getbeta')"
                            style="outline: none;"
                    >
                        Try Beta
                    </button>
                </li>

            </ul>

            <div class="active-li-bar"
                 data-anchor-active-bar
            >
            </div>

            <div class="burger-icon" tabindex="0" @click="showMobileNavbar = !showMobileNavbar">

                <span></span>
                <span></span>
                <span></span>

            </div>

            <transition name="slide-right">
                <div class="mobile-navbar" v-if="showMobileNavbar">

                    <ul>

                        <li>
                            <a @click="scrollTo('home')">
                                Home
                            </a>
                        </li>
                        <li>
                            <a @click="scrollTo('market')">
                                Market
                            </a>
                        </li>
                        <li>
                            <a @click="scrollTo('features', 'start')">
                                Features
                            </a>
                        </li>
                        <li>
                            <a @click="scrollTo('roadmap')">
                                Roadmap
                            </a>
                        </li>
                        <li>
                            <a @click="scrollTo('pricing')">
                                Pricing
                            </a>
                        </li>
                        <li>
                            <a @click="scrollTo('funding')">
                                Funding
                            </a>
                        </li>
                        <li>
                            <button class="btn is-rounded"
                                    @click="scrollTo('getbeta')"
                                    style="outline: none;"
                            >
                                Try Beta
                            </button>
                        </li>

                    </ul>

                </div>
            </transition>


        </div>

    </header>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            return {
                headerIsDark: false,
                showMobileNavbar: false
            }
        },
        methods: {
            scrollTo(id, position) {

                this.showMobileNavbar = false
                this.$parallax.scrollTo(id, position)

            }
        },
        mounted() {

            this.$parallax.addScrollCallback(() => {

                if (window.scrollY < window.innerHeight / 20) {
                    this.headerIsDark = false
                } else {
                    this.headerIsDark = true
                }

            })

        }
    }
</script>

<style>
    .slide-right-enter-active, .slide-right-leave-active {
        transition: .5s ease-out;
        transform: translateX(0px);
    }
    .slide-right-enter, .slide-right-leave-to {
        transform: translateX(100%);
    }
</style>